
import { useEffect, useRef, useState } from "react";

function useScrollReveal(options = {}) {
    const elementRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    const {
        threshold = 0.12,
        rootMargin = "0px 0px -40px 0px",
    } = options;

    useEffect(() => {
        const element = elementRef.current;

        if (!element) return;

        // Respetar la preferencia de reducir animaciones.
        const prefersReducedMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)"
        ).matches;

        if (prefersReducedMotion) {
            setIsVisible(true);
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);

                    // Ejecutar la animación una sola vez.
                    observer.unobserve(entry.target);
                }
            },
            {
                threshold,
                rootMargin,
            }
        );

        observer.observe(element);

        return () => observer.disconnect();
    }, [threshold, rootMargin]);

    return {
        elementRef,
        isVisible,
    };
}

export default useScrollReveal;
